import React, { useEffect, useRef, useState } from "react";
import { TypeAnimation } from "react-type-animation";

import { motion, AnimatePresence } from "motion/react";
import { ActionButton } from "../component/buttons";
import { StatList } from "./statsList";

export const StatsMostPlayedList = ({ type, data, next }) => {
  const [hide, setHide] = useState(false);
  const [showResult, setShowResult] = useState(false);

  return (
    <motion.div className="app-stats-intro-content" key={"step-" + type}>
      <div
        className="center-container single-most-played-container list-most-played-container"
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: "0%" }}
        exit={{ opacity: 0, y: "-400%" }}
        transition={{
          duration: 1.0,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <TypeAnimation
          key={type}
          className="light-headline list-headline"
          sequence={[
            "top 5",
            1000,
            "top 5 " + type,
            500,
            () => {
              setShowResult(true);
            },
          ]}
          typeSpeed={420}
        />

        <motion.div
          className="column-layout list-container"
          initial={{ opacity: 0, y: "100%" }}
          animate={{
            opacity: showResult ? 1 : 0,
            y: showResult ? "0%" : "100%",
          }}
          exit={{ opacity: 0, y: "-400%" }}
          transition={{
            duration: 1.0,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <StatList data={data} type={type} />

          <button className="bottom-actions" onClick={() => next()}>
            <ActionButton title="next" />
          </button>
        </motion.div>
      </div>
    </motion.div>
  );
};
